import BriefsOverview from './BriefsOverview'
import BriefContent from './brief-content'
import StrategyTab from './brief-content/StrategyTab'
import Reporting from './brief-content/Reporting'
import ComparisonTab from '@/features/reports/rank-zone/competition/Competition'
import CreationTab from './brief-content/Creation'
import PublishingTab from './brief-content/PublishingTab'

/**
 * content brief overview / content routes
 */
export default [
  // {
  //   path: '/content-briefs',
  //   name: 'BriefsOverview',
  //   component: BriefsOverview
  // },
  {
    path: '/content-briefs/:id',
    name: 'BriefContent',
    component: BriefContent,
    redirect: { name: 'BriefStrategy' },
    props: (route) => ({ integrationError: route.query.err, integrationStatus: route.query.integration_status, advancedFilters: route.query.advancedFilters }),
    children: [
      // strategy tab route. though it looks like tab on UI this component is routed
      {
        path: 'strategy',
        name: 'BriefStrategy',
        component: StrategyTab,
        props: true

      },
      // route for PDF export strategy tab variant
      {
        path: 'strategy/print',
        name: 'BriefStrategyPrint',
        component: StrategyTab,
        props: { isStaticView: true }
      },
      // reporting tab route.  though it looks like tab on UI this component is routed
      {
        path: 'progress',
        name: 'BriefReporting',
        component: Reporting
      },
      // route for PDF export reporting tab variant
      {
        path: 'progress/print',
        name: 'BriefReportingPrint',
        component: Reporting,
        props: { isStaticView: true }
      },
      // reporting tab route.  though it looks like tab on UI this component is routed
      {
        path: 'reporting',
        name: 'OldBriefReporting',
        redirect: { name: 'BriefReporting' }
      },
      // route for PDF export reporting tab variant
      {
        path: 'reporting/print',
        name: 'OldBriefReportingPrint',
        redirect: { name: 'BriefReportingPrint' }
      },
      // reporting tab route.  though it looks like tab on UI this component is routed
      {
        path: 'comparison',
        name: 'BriefComparison',
        component: ComparisonTab
      },
      // route for PDF export reporting tab variant
      {
        path: 'comparison/print',
        name: 'BriefComparisonPrint',
        component: ComparisonTab,
        props: { isStaticView: true }
      },
      // reporting tab route.  though it looks like tab on UI this component is routed
      {
        path: 'optimize',
        name: 'CreationTab',
        component: CreationTab
      },
      {
        path: 'creation',
        name: 'CreationTab',
        component: CreationTab
      },
      // route for PDF export reporting tab variant
      {
        path: 'creation/print',
        name: 'CreationTabPrint',
        component: CreationTab,
        props: { isStaticView: true }
      },
      // publishing tab route.  though it looks like tab on UI this component is routed
      {
        path: 'publishing',
        name: 'BriefPublishing',
        component: PublishingTab
      }
    ]
  }
]
